import { render, staticRenderFns } from "./CategoriesHorse.vue?vue&type=template&id=af5e7cd8&"
import script from "./CategoriesHorse.vue?vue&type=script&lang=js&"
export * from "./CategoriesHorse.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports